const LANGFUSE_BASE_URL = import.meta.env.VITE_LANGFUSE_BASE_URL ?? "";
const LANGFUSE_PROJECT_ID = import.meta.env.VITE_LANGFUSE_PROJECT_ID ?? "";

export function getLangfuseSpanUrl(traceId: string, spanId: string): string | null {
  if (!LANGFUSE_BASE_URL || !LANGFUSE_PROJECT_ID) return null;
  return `${LANGFUSE_BASE_URL}/project/${LANGFUSE_PROJECT_ID}/traces/${traceId}?observation=${spanId}`;
}

export function getLangfuseTraceUrl(traceId: string): string | null {
  if (!LANGFUSE_BASE_URL || !LANGFUSE_PROJECT_ID) return null;
  return `${LANGFUSE_BASE_URL}/project/${LANGFUSE_PROJECT_ID}/traces/${traceId}`;
}

export function getLangfuseSessionUrl(sessionId: string): string | null {
  if (!LANGFUSE_BASE_URL || !LANGFUSE_PROJECT_ID) return null;
  return `${LANGFUSE_BASE_URL}/project/${LANGFUSE_PROJECT_ID}/sessions/${encodeURIComponent(sessionId)}`;
}
